<div class="conversation-window-wrapper chat-panel">
  <div [ngClass]="'conversation-stack'">
    @if (chat) {
      <app-conversation-window-header [chatInfo]="chat"></app-conversation-window-header>
      <app-chat-message id="chatMessages" [ngClass]="'chat-wrapper'" [conversation]="chat"></app-chat-message>
      @if (chat && chat.isOpen) {
        <text-input
          [ngClass]="'message-window'"
          [placeholderText] = "'Type a new message'"
          [textlines] = 4
          [(value)]="message"
          [characterLimit] = 2000/>
          <div [ngClass]="'send-button-row'">
            @if (errorState) {
              <div class="criteria-error-text">
                {{errorMessage}}
              </div>
            }
            <img [ngClass]="'send-button'" (click)="sendMessage()" src="assets/icon/Send-Arrow.svg">
          </div>
        }
      } @else {
        <div class="no-chat-wrapper">
          @if (!loading) {
            <h2>No Chat Selected</h2>
            <p>Select a chat to read.</p>
          } @else {
            <mat-spinner></mat-spinner>
          }
        </div>
      }
    </div>
  </div>
